import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { PermissionCatalog } from '@/types/settings';

export function usePermissionCatalog() {
  return useApiQuery<PermissionCatalog>({
    queryKey: settingsKeys.permissionCatalog(),
    queryFn: () =>
      apiGet<PermissionCatalog>(operationsClient, settingsEndpoints.permissionCatalog()),
    showErrorToast: false,
  });
}
